import { NotificationProvider } from 'features/notifications';
import { NotificationCenter as NotificationCenterComponent } from 'features/notifications/components/notification-center';

export const NotificationCenter = () => (
  <NotificationProvider>
    <NotificationCenterComponent />
  </NotificationProvider>
);